import { setContactDetailsField, useContactDetailsDispatch } from '@context/ContactDetailsContext'
import { BookingFor } from '@customTypes/BookingFor'
import { isChildProphylaxis } from './useIsChildProphylaxis'

export const useMakeAdditionalActionIfChildProphylaxis = () => {
  const contactDetailsDispatch = useContactDetailsDispatch()

  return (treatmentPurposeReferenceId?: string) => {
    if (isChildProphylaxis(treatmentPurposeReferenceId || ''))
      contactDetailsDispatch(setContactDetailsField('bookingFor', BookingFor.BOOKING_FOR_OTHER))
  }
}
